<template>
  <div class="animated fadeIn">
    <b-row class>
      <b-col>
        <h2>ตั้งรหัสผ่าน</h2>
      </b-col>
    </b-row>
    <b-row v-if="showRegForm" class="mt-2">
      <b-col sm="6" md="4">
        <TextInput
          :value="$v.email"
          id="email"
          feedback="ระบุอีเมล"
          label="อีเมล"
          placeholder="ตัวอย่าง: user@logisty.asia"
          :isRequired="true"
        />
      </b-col>
    </b-row>
    <b-row v-if="showRegForm" class="mt-2">
      <b-col sm="6" md="4">
        <TextInput
          :value="$v.password"
          id="password"
          feedback="จำเป็นต้องระบุ"
          label="รหัสผ่าน"
          placeholder
          :isRequired="true"
          type="password"
        />
      </b-col>
    </b-row>
    <b-row v-if="showRegForm" class="mt-2">
      <b-col sm="6" md="4">
        <TextInput
          :value="$v.companyName"
          id="companyName"
          feedback="จำเป็นต้องระบุ"
          label="ชื่อบริษัท"
          placeholder
          :isRequired="true"
          type="text"
        />
      </b-col>
    </b-row>
    <b-row v-if="showRegForm" class="mt-2">
      <b-col sm="6" md="4">
        <TextInput
          :value="$v.name"
          id="name"
          feedback="จำเป็นต้องระบุ"
          label="ชื่อ-นามสกุล"
          placeholder
          :isRequired="true"
          type="text"
        />
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col sm="6" md="4">
        <label for="phoneNumber">เบอร์โทร</label>
        <b-input-group>
          <b-form-input v-model="phoneNumber" id="phoneNumber"></b-form-input>
          <b-input-group-append>
            <b-button variant="primary" id="otp-button" @click="requestOTP">ส่งรหัส OTP</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row v-if="showRegForm" class="mt-2">
      <b-col sm="6" md="4">
        <TextInput
          :value="$v.otp"
          id="otp"
          feedback="ระบุ otp"
          label="รหัส OTP ที่ได้รับ"
          placeholder="ตัวอย่าง: 123456"
          :isRequired="true"
        />
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col sm="6" md="4">
        <b-button variant="primary" @click="register">ยืนยัน</b-button>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col sm="6" md="4">
        หรือเข้าสู่ระบบ
        <b-link :to="{name: 'เข้าสู่ระบบ'}">คลิกที่นี่</b-link>
      </b-col>
    </b-row>
    <ModalLoading />
  </div>
</template>

<script>
import firebase from 'firebase'
import ModalLoading from '../components/ModalLoading'
import TextInput from '../components/TextInput'
import User from '../services/http/User'
import Company from '../services/http/Company'

import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'

export default {
  components: {
    ModalLoading,
    TextInput
  },
  mixins: [validationMixin],
  validations: {
    email: {
      required,
      email
    },
    password: {
      required
    },
    companyName: {
      required
    },
    name: {
      required
    },
    otp: {
      required
    }
  },
  data () {
    return {
      phoneNumber: null,
      otp: null,
      email: null,
      password: null,
      companyName: null,
      name: null,
      showRegForm: true
    }
  },
  async mounted () {
    firebase.auth().languageCode = 'th'

    // Start Firebase invisible reCAPTCHA verifier
    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('otp-button', {
      'size': 'invisible',
      'callback': function (response) {
        // reCAPTCHA solved, allow signInWithPhoneNumber.
        // console.log('invisable')
        console.log('allow')
      }
    })

    window.recaptchaVerifier.render().then((widgetId) => {
      window.recaptchaWidgetId = widgetId
    })
  },
  methods: {
    async requestOTP () {
      var phoneNumberPrefix = '+66'
      var phoneNumber = phoneNumberPrefix + this.phoneNumber.slice(1)
      var appVerifier = window.recaptchaVerifier

      Window.Event.$emit('showModalLoading')
      console.log(Window.Event)
      var result = await firebase.auth().signInWithPhoneNumber(phoneNumber, appVerifier)
        .then(function (confirmationResult) {
          // SMS sent. Prompt user to type the code from the message, then sign the
          // user in with confirmationResult.confirm(code).
          window.confirmationResult = confirmationResult
          return true
        }).catch(function (error) {
          // Error; SMS not sent
          // ...

          console.log('signin' + error)
          return false
        })

      Window.Event.$emit('closeModalLoading')

      if (result) {
        console.log('requested otp')
        // this.showRegForm = true
      } else {
        alert('โปรดติดต่อผู้ดูแลระบบ')
        grecaptcha.reset(window.recaptchaWidgetId)
      }
    },
    async register () {
      this.$v.$touch()

      if (this.$v.$anyError) {
        return
      }

      Window.Event.$emit('showModalLoading')

      var result = await confirmationResult.confirm(this.otp).then(function (result) {
        // User signed in successfully.
        var user = result.user
        // console.log(user)
        return true
      }).catch(function (error) {
        // User couldn't sign in (bad verification code?)
        // ...
        console.log(error)
        return false
      })

      if (result) {
        var user = new User()
        var data = {
          phoneNumber: this.phoneNumber,
          password: this.password,
          email: this.email,
          companyName: this.companyName,
          name: this.name
        }

        try {
          var reg = await user.emailRegister(data)
          if (reg.code === 1) {
            alert('ลงทะเบียนสำเร็จ')
            this.$cookies.set('email', this.email)
            this.$cookies.set('token', reg.token)
            window.analytics.identify({ email: this.email })
            window.analytics.track('register', { email: this.email })
            Window.Event.$emit('checkLogin')
            await this.$store.dispatch('checkCompanyStatus')
            var company = new Company()
            var companyInfo = await company.getCompanyInfo()
            if (companyInfo.profileUrl) {
              this.$router.push({ name: 'โปรไฟล์', params: { companyUrl: companyInfo.profileUrl } })
            } else {
              this.$router.go()
            }
          } else if (reg.code === 110) {
            alert('มี email ในระบบแล้ว')
            this.otp = null
          } else {
            alert('โปรดติดต่อผู้ดูแลระบบ')
          }
        } catch (error) {
          console.log(error)
          alert('โปรดติดต่อผู้ดูแลระบบ')
          grecaptcha.reset(window.recaptchaWidgetId)
        }
      } else {
        alert('รหัส OTP ไม่ถูกต้อง')
      }

      Window.Event.$emit('closeModalLoading')
    }
  }
}
</script>
